import { createStore } from 'vuex'

const storeLeaseItNow = createStore({
  state() {
    return {
      type: false,
      brands: [],
      brandsArgs: [],
      models: [],
      modelsArgs: [],
      editions: [],
      editionsArgs: [],
      fuels: [],
      fuelsArgs: [],
      bodyTypes: [],
      transmissions: [],
      prices: [],

      // car page
      deposit: 0,
      extras: 0,
      extrasOptionIds: [],
      numOfPayments: 0,
      annualKm: 0,
      buyback: false,
      buybackAmount: 0,

      rentalPrice: 0,
      vat: 0,
      finalPrice: 0,
      extraPrice: 0,

      recordsCompare: [],
    }
  },
  mutations: {
    setField(state, payload) {
      state[payload.field] = payload.value
    },
    addRecordToCompare(state, payload) {
      state.recordsCompare.push(payload.value)
    },
    removeRecordFromCompare(state, payload) {
      const index = state.recordsCompare.findIndex(
        (i) => i.vehicle_id === payload.value
      )

      if (index === -1) {
        return false
      }

      state.recordsCompare.splice(index, 1)
    },
  },
  getters: {
    getField: (state) => (field) => {
      return state[field]
    },
    getFiltersCount: (state) => () => {
      let count = 0

      if (state.brands.length || state.brandsArgs.length) {
        count += 1
      }
      if (state.models.length || state.modelsArgs.length) {
        count += 1
      }
      if (state.fuels.length || state.fuelsArgs.length) {
        count += 1
      }
      if (state.transmissions.length) {
        count += 1
      }

      return count
    },
  },
})

export default storeLeaseItNow
